import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16 } from '@onefootprint/icons';
import type { PillProps } from '../pill';
import Pill from '../pill';
const AddPill = t0 => {
  const $ = _c(7);
  const {
    children,
    onClick,
    disabled
  } = t0;
  const t1 = disabled ? "quaternary" : "tertiary";
  let t2;
  if ($[0] !== t1) {
    t2 = <IcoPlusSmall16 color={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== disabled || $[4] !== onClick || $[5] !== t2) {
    t3 = <Pill className="border-dashed!" onClick={onClick} type="button" disabled={disabled}>{t2}{children}</Pill>;
    $[2] = children;
    $[3] = disabled;
    $[4] = onClick;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default AddPill;